<template>
  <div class="invoice ">
    <headd :mobile_title="mobile_title"></headd>
    <div class="form container">
      <div class="f_title">购货单位/受票方</div>
      <div class="f_cell">
        <div class="cell_title">选择公司</div>
        <div class="cell_vaule">
          <select
            class="select"
            v-model="CompanysSelected"
            @change="getCompanysSelected($event)"
          >
            <option
              :value="coupon.credit_code"
              v-for="coupon in companys"
              :key="coupon.credit_code"
              >{{ coupon.company_title }}</option
            >
          </select>
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">开票抬头</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.buyer_title"
            type="text"
            placeholder="请输入开票抬头"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">发票类型</div>
        <div class="cell_vaule">
          <div class="cellradio">
            <input
              type="radio"
              id="zhuanyong"
              v-model="invoiceApply.invoice_type"
              value="专用发票"
            />
            <label for="zhuanyong">专用发票</label>
          </div>
          <div class="cellradio">
            <input
              type="radio"
              id="putong"
              v-model="invoiceApply.invoice_type"
              value="普通发票"
            />
            <label for="putong">普通发票</label>
          </div>
        </div>
      </div>
    </div>
    <div class="form container">
      <div class="f_title">
        明细
        <div class="op" @click="add">
          <img
            class="op_icon"
            src="../../static/user/icon_11.png"
          />点击添加一行
        </div>
      </div>
      <div class="tablelist">
        <div class="tb_item">
          <div class="f_cell" style="width: 100%;">
            <div class="cell_title" style="width: 263rpx;">
              货物或应税劳务名称
            </div>
            <div class="cell_vaule" style="width: 363rpx;">
              <input
                class="input"
                data-index="0"
                v-model="invoiceApply.itemdesc[0].itemtitle"
                type="text"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="f_cell">
            <div class="cell_title">规格型号</div>
            <div class="cell_vaule">
              <input
                class="input"
                data-index="0"
                v-model="invoiceApply.itemdesc[0].model"
                type="text"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="f_cell">
            <div class="cell_title">单位</div>
            <div class="cell_vaule">
              <input
                class="input"
                data-index="0"
                v-model="invoiceApply.itemdesc[0].unit"
                type="text"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="f_cell">
            <div class="cell_title">数量</div>
            <div class="cell_vaule">
              <input
                class="input"
                data-index="0"
                v-model="invoiceApply.itemdesc[0].num"
                type="number"
                min="1"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="f_cell">
            <div class="cell_title">单价</div>
            <div class="cell_vaule">
              <input
                class="input"
                data-index="0"
                v-model="invoiceApply.itemdesc[0].price"
                type="number"
                min="1"
                placeholder="请输入"
              />
            </div>
          </div>
        </div>
        <div
          v-for="(item, index) in invoiceApply.itemdesc"
          :key="item.id"
          v-show="invoiceApply.itemdesc.length > 0"
        >
          <div class="tb_item" v-if="index > 0">
            <img
              src="../../static/user/icon_12.png"
              class="delete"
              :data-index="index"
              @click="del"
            />
            <div class="f_cell" style="width: 100%;">
              <div class="cell_title" style="width: 263rpx;">
                货物或应税劳务名称
              </div>
              <div class="cell_vaule" style="width: 363rpx;">
                <input
                  class="input"
                  :data-index="index"
                  v-model="item.itemtitle"
                  type="text"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="f_cell">
              <div class="cell_title">规格型号</div>
              <div class="cell_vaule">
                <input
                  class="input"
                  :data-index="index"
                  v-model="item.model"
                  type="text"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="f_cell">
              <div class="cell_title">单位</div>
              <div class="cell_vaule">
                <input
                  class="input"
                  :data-index="index"
                  v-model="item.unit"
                  type="text"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="f_cell">
              <div class="cell_title">数量</div>
              <div class="cell_vaule">
                <input
                  class="input"
                  :data-index="index"
                  v-model="item.num"
                  type="number"
                  min="1"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="f_cell">
              <div class="cell_title">单价</div>
              <div class="cell_vaule">
                <input
                  class="input"
                  :data-index="index"
                  v-model="item.price"
                  type="number"
                  min="1"
                  placeholder="请输入"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="total">
          金额合计 ：<span class="price">{{ all_price }} 元</span>
        </div>
      </div>
    </div>
    <div class="form container">
      <div class="f_cell">
        <div class="cell_title">收款人</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.payee"
            type="text"
            placeholder="请输入收款人"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">所在城市</div>
        <div class="cell_vaule">
          <!-- {{ classifyArr[0] }} -->
          <select class="select" @change="getshengselected($event)">
            <option v-for="item in classifyArr[0]" :key="item.id">{{
              item.name
            }}</option></select
          >

          <select class="select"
            ><option v-for="item in childArr[i]" :key="item.id">{{
              item.name
            }}</option></select
          >
          <!-- <picker
            class="item-picker"
            mode="multiSelector"
            range-key="name"
            @change="classifyChange"
            @columnchange="columnchange"
            :value="classifyIndex"
            :range="classifyArr"
          >
            <div style="font-size: 30rpx;">{{ name }}</div>
          </picker> -->
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">地址</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.express_address"
            type="text"
            placeholder="请输入地址"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">联系人</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.express_name"
            type="text"
            placeholder="请输入联系人姓名"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">电话号码</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.express_tel"
            type="tel"
            placeholder="请输入您的电话号码"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">备注</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.remark"
            type="text"
            placeholder="请输入您的发票备注"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">快递费</div>
        <div class="cell_vaule">
          <input
            class="input"
            v-model="invoiceApply.express_price"
            disabled="disabled"
            type="text"
            placeholder="请输入地址"
          />
        </div>
      </div>
    </div>
    <div class="btn_save_red" @click="btn_save">提交</div>

    <el-dialog :visible.sync="dialogFormVisible" width="6rem">
      <div class="code_con">
        <div id="qrCode" ref="qrCodeDiv"></div>
        <div class="qr_tip">
          <span
            >请保存二维码图片到手机，<br />使用微信识别二维码打开填写开票信息推送开票系统（专票请填写完整银行信息）</span
          >
        </div>
      </div>
    </el-dialog>
    <foot></foot>
  </div>
</template>

<script>
// import qrCode from '@/common/wxqrcode.js'
// import uniPopup from '../../components/uni-popup/uni-popup.vue'
// import pickRegions from '@/components/pick-regions/pick-regions.vue'
// import savefile from '@/components/p-saveFile/saveFile.vue'
import headd from "@/components/head";
import foot from "@/components/foot";
import QRCode from "qrcodejs2";
import { MessageBox, Toast } from "mint-ui";
import {
  getinvoicecompany,
  getinvoiceExpressFee,
  getinvoiceApply
} from "./api/api"; //引入api里面定义的方法
export default {
  components: {
    //pickRegions,
    //savefile
    headd,
    foot
  },
  data() {
    return {
      mobile_title: "开票申请",
      dialogFormVisible: false,
      value: "",
      i: 0,
      region: [],
      optionlist: [],

      qr: "",
      CompanysSelected: "请选择",
      invoiceApply: {
        all_price: 0,
        invoice_type: "专用发票",
        itemdesc: [
          {
            itemtitle: "",
            model: "",
            unit: "",
            num: "",
            price: ""
          }
        ],
        sales_title: "",
        payee: "",
        buyer_title: "",
        express_address: "",
        express_name: "",
        express_tel: "",
        remark: "",
        express_price: ""
      },
      items: [
        {
          value: "1",
          name: "专用发票"
        },
        {
          value: "2",
          name: "普通发票"
        }
      ],
      current: 0,
      index2: 0,
      index3: 0,
      companys: [],
      ExpressFee: [],
      name: "请选择城市",
      classifyArr: [[], []], // picker - 数据源
      classifyIndex: [0, 0], // picker - 索引
      childArr: [] // 二级分类数据源
    };
  },

  computed: {
    all_price() {
      let all_pricec = 0;
      this.invoiceApply.itemdesc.map(item => {
        all_pricec += item.num * item.price;
      });
      return all_pricec;
    },
    regionName() {
      // 转为字符串
      return this.region.map(item => item.name).join(" ");
    }
  },
  mounted() {
    this.myjizhanglist();
    this.invoiceExpressFeelist();
    // this.$nextTick(function() {
    //   this.creatQrCode();
    // });
  },
  methods: {
    creatQrCode() {},
    handleChange(value) {
      console.log(value);
    },
    hidePhoto() {
      uni.showToast({
        title: "图片已隐藏",
        icon: "none"
      });
    },
    // 获取选择的地区
    handleGetRegion(region) {
      this.region = region;
    },
    radioChange: function(evt) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].value === evt.target.value) {
          this.current = i;
          this.invoiceApply.invoice_type = this.items[i].name;
          //console.log(this.invoiceApply.invoice_type)
          break;
        }
      }
    },
    async myjizhanglist() {
      var _self = this;
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getinvoicecompany(data);

      _self.companys = [
        {
          credit_code: "请选择",
          company_title: "请选择"
        },
        ...res.data.data.companys
      ];

      //console.log(res.data.data.companys);
    },

    async invoiceExpressFeelist() {
      var _self = this;
      const res = await getinvoiceExpressFee();
      //console.log(res.data.data);
      var dataSource = Object.values(res.data.data);
      let dataLen = dataSource.length;
      _self.classifyArr[0] = Object.values(res.data.data);
      _self.childArr = dataSource.map(item => item.child);
      _self.classifyArr[1] = _self.childArr[0];

      this.invoiceApply.express_province = _self.classifyArr[0][0].name;
      this.invoiceApply.express_price = this.childArr[0][0].price;
      this.invoiceApply.express_city = this.childArr[0][0].name;
    },

    getshengselected(e) {
      //console.log(e);
      //console.log(e.target.selectedIndex); // 选择项的index索引
      //console.log(e.target.value); // 选择项的valuei
      this.i = e.target.selectedIndex;

      //console.log(this.childArr[e.target.selectedIndex][0].price);
      this.invoiceApply.express_province = e.target.value;
      this.invoiceApply.express_price = this.childArr[
        e.target.selectedIndex
      ][0].price;
      this.invoiceApply.express_city = this.childArr[
        e.target.selectedIndex
      ][0].name;
    },

    getCompanysSelected(e) {
      //console.log(e);
      //console.log(e.target.selectedIndex); // 选择项的index索引
      //console.log(e.target.value); // 选择项的value
      var _self = this;
      var index = e.target.selectedIndex;
      console.log(e);
      _self.index2 = index;
      if (index > 0) {
        _self.invoiceApply.sales_title = _self.companys[index].company_title;
        _self.invoiceApply.sales_code = _self.companys[index].credit_code;
        _self.company_invoice_code = _self.companys[index].company_invoice_code;
      }
    },

    // 选择商品分类e
    classifyChange(e) {
      console.log();
      let value = e.target.value;
      this.classifyIndex = value;

      if (this.classifyArr[0].length != 0) {
        this.name = this.classifyArr[0][this.classifyIndex[0]].name;
        this.invoiceApply.express_province = this.classifyArr[0][
          this.classifyIndex[0]
        ].name;
      }

      if (this.classifyArr[1].length != 0) {
        this.name += "," + this.classifyArr[1][this.classifyIndex[1]].name;
        this.invoiceApply.express_price = this.classifyArr[1][
          this.classifyIndex[1]
        ].price;
        this.invoiceApply.express_city = this.classifyArr[1][
          this.classifyIndex[1]
        ].name;
        //onsole.log(this.classifyArr[1][this.classifyIndex[1]].price)
      }
    },
    columnchange(e) {
      //console.log(e)
      var _self = this;
      // 当滚动切换一级分类时，为当前的一级分类添加它的子类
      if (e.detail.column == 0) {
        // #ifdef H5
        // 在小程序中直接赋值无效  H5 可直接赋值
        _self.classifyArr[1] = _self.childArr[e.detail.value];
        // #endif

        // #ifdef MP-WEIXIN
        // 在 H5 环境下 $set 会导致一级分类无法滚动， 小程序正常运行
        _self.$set(_self.classifyArr, 1, _self.childArr[e.detail.value]);
        // #endif

        // #ifdef APP-PLUS
        //console.log(_self.childArr[e.detail.value])
        _self.classifyArr[1] = _self.childArr[e.detail.value];
        //console.log(_self.classifyArr)

        _self.$forceUpdate();

        // #endif
      }
    },

    getitemtitle(e) {
      //console.log(e)
      var that = this;
      var index = parseInt(e.currentTarget.dataset.index);
      var apply_list = that.invoiceApply.itemdesc;
      apply_list[index]["itemtitle"] = e.detail.value;
      that.invoiceApply.itemdesc = apply_list;
    },
    getmodel(e) {
      //console.log(e)
      var that = this;
      var index = parseInt(e.currentTarget.dataset.index);
      var apply_list = that.invoiceApply.itemdesc;
      apply_list[index]["model"] = e.detail.value;
      that.invoiceApply.itemdesc = apply_list;
    },
    getunit(e) {
      //console.log(e)
      var that = this;
      var index = parseInt(e.currentTarget.dataset.index);
      var apply_list = that.invoiceApply.itemdesc;
      apply_list[index]["unit"] = e.detail.value;
      that.invoiceApply.itemdesc = apply_list;
    },
    getnum(e) {
      //console.log(e)
      var that = this;
      var index = parseInt(e.currentTarget.dataset.index);
      var apply_list = that.invoiceApply.itemdesc;
      apply_list[index]["num"] = e.detail.value;
      that.invoiceApply.itemdesc = apply_list;
    },
    getprice(e) {
      //console.log(e)
      var that = this;
      var index = parseInt(e.currentTarget.dataset.index);
      var apply_list = that.invoiceApply.itemdesc;
      apply_list[index]["price"] = e.detail.value;
      that.invoiceApply.itemdesc = apply_list;
    },
    add(e) {
      var that = this;
      var list = that.invoiceApply.itemdesc;
      console.log(list.length);

      var parm = {
        itemtitle: "",
        model: "",
        unit: "",
        num: "",
        price: ""
      };
      var that = this;
      var apply_list = [];
      var app = [];
      app.push(parm);
      var apply = that.invoiceApply.itemdesc;
      apply = apply.concat(app);
      apply_list = apply;
      console.log(apply_list);
      that.invoiceApply.itemdesc = apply_list;
    },
    del(e) {
      console.log(e);
      var that = this;
      var index = e.currentTarget.dataset.index;
      var list = that.invoiceApply.itemdesc;
      list.splice(index, 1);
      that.invoiceApply.itemdesc = list;
    },
    async btn_save() {
      var _self = this;

      _self.invoiceApply.uid = localStorage.getItem("userId");
      _self.invoiceApply.all_price = _self.all_price;
      console.log(_self.invoiceApply);

      var data = _self.invoiceApply;

      if (data.sales_title == "") {
        this.$toast("请选择公司");
        return false;
      }
      if (data.buyer_title == "") {
        this.$toast("请输入开票抬头");
        return false;
      }
      if (data.itemdesc[0].itemtitle == "") {
        this.$toast("请添加明细");
        return false;
      }
      if (data.payee == "") {
        this.$toast("请输入收款人");
        return false;
      }
      if (data.express_address == "") {
        this.$toast("请输入地址");
        return false;
      }
      if (data.express_name == "") {
        this.$toast("请输入联系人");
        return false;
      }
      if (data.express_tel == "") {
        this.$toast("请输入电话号码");
        return false;
      }

      MessageBox.confirm("是否确定提交")
        .then(action => {
          _self.api(data);
        })
        .catch(() => {
          Toast({
            message: "已取消"
          });
        });
    },
    async api(obj) {
      console.log(obj);
      var _self = this;
      var param = {
        uid: obj.uid,
        sales_title: obj.sales_title,
        sales_code: obj.sales_code,
        buyer_title: obj.buyer_title,
        invoice_type: obj.invoice_type,
        itemdesc: JSON.stringify(obj.itemdesc),
        all_price: obj.all_price,
        payee: obj.payee,
        express_province: obj.express_province,
        express_city: obj.express_city,
        express_address: obj.express_address,
        express_name: obj.express_name,
        express_tel: obj.express_tel,
        remark: obj.remark
      };
      //   const res = await this.$myRuquest({
      //     url: "/invoiceApply",
      //     data: param,
      //     method: "POST"
      //   });
      const res = await getinvoiceApply(param);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.invoiceApply = {
          all_price: 0,
          invoice_type: "专用发票",
          itemdesc: [
            {
              itemtitle: "",
              model: "",
              unit: "",
              num: "",
              price: ""
            }
          ],
          payee: "",
          buyer_title: "",
          express_address: "",
          express_name: "",
          express_tel: "",
          remark: "",
          express_price: ""
        };
        _self.dialogFormVisible = true;
        _self.$nextTick(function() {
          var qrcode = new QRCode(this.$refs.qrCodeDiv, {
            text: _self.company_invoice_code,
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
          });
        });

        // return uni.showToast({
        //   title: "提交成功",
        //   complete: function(res) {
        //     // 二维码生成工具

        //     _self.qr = qrCode.createQrCodeImg(_self.company_invoice_code);
        //     _self.$refs.popup.open();
        //     _self.invoiceApply = {
        //       all_price: 0,
        //       invoice_type: "专用发票",
        //       itemdesc: [
        //         {
        //           itemtitle: "",
        //           model: "",
        //           unit: "",
        //           num: "",
        //           price: ""
        //         }
        //       ],
        //       payee: "",
        //       buyer_title: "",
        //       express_address: "",
        //       express_name: "",
        //       express_tel: "",
        //       remark: "",
        //       express_price: ""
        //     };

        //     _self.name = "请选择城市";
        //     _self.index2 = 0;
        //   }
        // });
      }
    }
  }
};
</script>

<style lang="less">
page {
  background-color: #f2f2f2;
}

.select {
  width: 100%;
  margin-right: 0.1rem;
  @media (max-width: 991px) {
    height: 0.84rem !important;
    line-height: 100%;
    display: flex;
    align-items: center;
    padding: 0 0.17rem;
  }

  &:last-child {
    margin-right: 0;
  }
}

.invoice {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;

  .form {
    width: 10rem;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0;
      margin-top: 0.32rem;
    }
  }
}

.common_poup {
  width: 626rpx;
  height: auto;
  background-color: #ffffff;
  padding: 50rpx 32rpx;
  border-radius: 20rpx;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .qr_img {
    width: 300rpx;
    height: 300rpx;
    margin-bottom: 20rpx;
  }

  .qr_tip {
    font-size: 26rpx;
    line-height: 42rpx;
    text-align: center;
  }
}
.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      margin-top: 0.2rem;
      font-size: 0.28rem;
      line-height: 0.33rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/invoice.vue